import styles from "./AddonItem.module.scss";
import { IAddon } from "../../../../models/Addon";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { useTranslation } from "react-i18next";
import { openSuccessMessage } from "../../../../store/message/messageSlice";
import editIcon from "../../../../assets/images/icons/edit-dark.svg";
import deleteIcon from "../../../../assets/images/icons/delete-red.svg";
import ConfirmPopup from "../../../../components/ConfirmPopup/ConfirmPopup";
import AddonPopup from "../AddonPopup/AddonPopup";
import { handleError } from "../../../../helper/errorHandler";
import { useAddonMutations } from "../../../../api/mutations";

interface IAddonItemProps {
  item: IAddon;
}

const AddonItem: React.FC<IAddonItemProps> = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [showAddonPopup, setShowAddonPopup] = useState<boolean>(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState<boolean>(false);
  const { deleteAddon } = useAddonMutations();

  const clickOnEdit = () => {
    setShowAddonPopup(true);
  };

  const clickOnDelete = () => {
    setShowConfirmPopup(true);
  };

  const onClickYes = () => {
    deleteAddon(item.id, {
      onSuccess: () => {
        dispatch(openSuccessMessage(t("AddonDeletedSuccessfully")));
        navigate(`/subscriptions/?shouldUpdateAddons=${true}`);
      },
      onError: (e) => handleError(e, dispatch, t),
    });
  };

  const onClickNo = () => {
    setShowConfirmPopup(false);
  };

  return (
    <div className={styles.item}>
      <p className={styles.price}>€{item.price}</p>
      <p className={styles.credit}>
        {item.credits} {t("Credit")}
      </p>
      <div className={styles.bottom}>
        <button className={`${styles.btn} ${styles.edit}`} onClick={clickOnEdit}>
          <img src={editIcon} alt={"edit"} />
          {t("Edit")}
        </button>
        <button className={`${styles.btn} ${styles.delete}`} onClick={clickOnDelete}>
          <img src={deleteIcon} alt={"delete"} />
          {t("Delete")}
        </button>
      </div>
      {showAddonPopup && <AddonPopup setShowCreatePopup={setShowAddonPopup} item={item} />}
      {showConfirmPopup && (
        <ConfirmPopup
          title={t("AreYouSureYouWantToDeleteThisAddon")}
          onClickYes={onClickYes}
          onClickNo={onClickNo}
        />
      )}
    </div>
  );
};

export default AddonItem;
